import { render, staticRenderFns } from "./PropertyBatchUpload.vue?vue&type=template&id=9f85354e&scoped=true&"
import script from "./PropertyBatchUpload.vue?vue&type=script&lang=js&"
export * from "./PropertyBatchUpload.vue?vue&type=script&lang=js&"
import style0 from "./PropertyBatchUpload.vue?vue&type=style&index=0&id=9f85354e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9f85354e",
  null
  
)

export default component.exports